/**
 * @generated SignedSource<<88ef0bfe5735f0c2e9dbfc07c35d5bd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type LearnableKind = "Course" | "GroupCoaching" | "MicroLearning" | "OneToOneCoaching";
import { FragmentRefs } from "relay-runtime";
export type learnableGrid_LearnableFragment$data = {
  readonly CustomerJourney: {
    readonly Dashboard: {
      readonly sortedLearnables: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly lastUpdated: string | null;
            readonly learnable: {
              readonly id: string;
              readonly kind: LearnableKind;
              readonly " $fragmentSpreads": FragmentRefs<"coachingLearnableCard_PublishedLearnableFragment" | "educationalOfferCard_PublishedCourseLearnableFragment">;
            };
          };
        } | null> | null;
      };
    } | null;
  };
  readonly " $fragmentType": "learnableGrid_LearnableFragment";
};
export type learnableGrid_LearnableFragment$key = {
  readonly " $data"?: learnableGrid_LearnableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"learnableGrid_LearnableFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "CustomerJourney",
  "Dashboard",
  "sortedLearnables"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "filterByCompleted"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "kinds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./learnableGridRefetchQuery.graphql')
    }
  },
  "name": "learnableGrid_LearnableFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerJourneyQueries",
      "kind": "LinkedField",
      "name": "CustomerJourney",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "filterByCompleted",
              "variableName": "filterByCompleted"
            },
            {
              "kind": "Variable",
              "name": "kinds",
              "variableName": "kinds"
            }
          ],
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "Dashboard",
          "plural": false,
          "selections": [
            {
              "alias": "sortedLearnables",
              "args": null,
              "concreteType": "SortedLearnablesConnection",
              "kind": "LinkedField",
              "name": "__learnableGrid_sortedLearnables_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SortedLearnablesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LearnableWithLastUpdated",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "learnable",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "id",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "kind",
                              "storageKey": null
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "educationalOfferCard_PublishedCourseLearnableFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "coachingLearnableCard_PublishedLearnableFragment"
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUpdated",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "bd00b1746d79486578644c21d4c49e45";

export default node;
